window.onload = function () {

    /* show / hide main nav
    -------------------------------------------------- */

    const nav = document.querySelector('.js-nav');
    const btnnav = document.querySelector('.js-toggle-icon');

    // Toggle menu to visible
    if (nav && btnnav) {
        btnnav.addEventListener("click", () => {
            nav.classList.toggle('is-open');
        });

        // Toggle burger and close icon
        btnnav.addEventListener("click", () => {
            // toggleCSSclasses(one, "icon-close");
            btnnav.classList.toggle('icon-close');
            btnnav.classList.toggle('icon-menu');
        });
    }
};

// Handle mobile navigation
document.addEventListener('DOMContentLoaded', () => {
    // Trigger
    let trigger = document.querySelector('.header-navigation-mobile-trigger');
    let mobileNavigation = document.querySelector('.mobile-navigation-container');

    if (trigger && mobileNavigation) {
        // Handle click event
        trigger.addEventListener('click', () => {
            trigger.classList.toggle('active');
            mobileNavigation.classList.toggle('active');
        });

        // Close mobile navigation on resize
        window.addEventListener('resize', () => {
            trigger.classList.remove('active');
            mobileNavigation.classList.remove('active');
        });
    }
});
